import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Icon,
  useToast
} from '@chakra-ui/react';
import { useRef } from 'react';
import { Button } from '../../../../../../components/Button';
import { api } from '../../../../../../services/api';
import { useMutation } from 'react-query';
import { useOrcamentoPedido } from '../../../../../../contexts/OrcamentoPedidoProvider';
import { IoMdPaper } from 'react-icons/io';

async function solicitarSt({ numeroNota }) {
  const response = await api.get('/site/v2/orcamento-crm/solicita-st-orcamento', {
    params: {
      numero_nota: numeroNota
    }
  });

  return response.data;
}

export function SolicitarST() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { infoProposta } = useOrcamentoPedido();
  const cancelRef = useRef();

  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true
  });

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: solicitarSt,
    onSuccess: () => {
      onClose();

      toast({
        title: 'ST solicitada com sucesso',
        status: 'success'
      });
    },
    onError: (error) => {
      toast({
        title: 'Erro ao solicitar ST',
        description: error?.response?.data?.erros || 'Erro inesperado',
        status: 'error'
      });
    }
  });

  async function handleSolicitarST(data) {
    if (!infoProposta?.disponivel_solicitar_st) {
      return;
    }

    await mutateAsync({
      numeroNota: infoProposta.num_proposta
    });
  }

  return (
    <>
      <Button
        disabled={infoProposta?.valida_proposta_nova || !infoProposta?.disponivel_solicitar_st}
        onClick={onOpen}
        border={0}
        borderRadius={0}
        bgColor="transparent"
        px={3}
        py={2}
        color="#2D2D2D"
        _hover={{
          bg: '#e2e2e2'
        }}
        fontWeight="normal"
        leftIcon={<Icon as={IoMdPaper} fontSize="20px" color="#378BBF" />}>
        Solicitar ST
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Deseja solicitar a ST?
            </AlertDialogHeader>

            <AlertDialogBody>Você está prestes a solicitar a ST!</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} bgColor="blue.500" onClick={onClose}>
                Cancelar
              </Button>
              <Button
                colorScheme="red"
                bgColor="green.500"
                onClick={handleSolicitarST}
                isLoading={isLoading}
                ml={3}>
                Confirmar ação
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
